var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5962 0.387097C13.0577 -0.129032 12.25 -0.129032 11.7115 0.387097L7 4.90322L2.28846 0.387097C1.75 -0.129032 0.942308 -0.129032 0.403846 0.387097C-0.134615 0.903226 -0.134615 1.67742 0.403846 2.19355L6.05769 7.6129C6.32692 7.87097 6.59615 8 7 8C7.40385 8 7.67308 7.87097 7.94231 7.6129L13.5962 2.19355C14.1346 1.67742 14.1346 0.903226 13.5962 0.387097Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserArrow);
export default __webpack_public_path__ + "static/media/user-arrow.0d9e29a9e3c85834afdb0185a845df20.svg";
export { ForwardRef as ReactComponent };